export default {
  // getActiveCharity: state => {
  //   return state.charities.find((charity) => charity.charity_id === state.activeCharityId)
  // },
  // getNotActiveCharities: state => {
  //   return state.charities.filter((charity) => charity.charity_id !== state.activeCharityId)
  // }
}
